import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import { Edit, SimpleForm } from "react-admin";
import { useState } from "react";
import BackButtonToolbar from "features/BackButtonToolbar";
import SaveForm from "./SaveForm";

const EditCurriculum = () => {
  const [pdfDocumentId, setPdfDocumentId] = useState(null);

  // Only the plan's own fields are sent — its collections are edited from the details page.
  const handleSend = ({
    name,
    degreeId,
    specialityId,
    studyTypeId,
    validFrom,
    yearsOfStudy,
    admissionAfterEducationLevelId,
  }) => ({
    name,
    degreeId,
    specialityId,
    studyTypeId,
    validFrom,
    yearsOfStudy,
    admissionAfterEducationLevelId,
    pdfDocumentId,
  });

  return (
    <Edit
      title="Редакция на учебен план"
      transform={handleSend}
      mutationMode="pessimistic"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
        <SaveForm setPdfDocumentId={setPdfDocumentId} />
      </SimpleForm>
    </Edit>
  );
};

export default EditCurriculum;
